import { Term } from './policy'

export interface CreateOnboardingUser {
  email: string
  phone: string
  name?: string
  supplier_id: string
  supplier_slug?: string
  natural_person_document_number: string
  legal_person_document_number: string
  terms?: Partial<Term>[]
}

export interface CreateMerchantUserBySalesperson {
  email: string
  phone_number: string
  natural_person_name: string
  natural_person_document_type: string
  legal_person_document_type: string
  natural_person_document_number: string
  legal_person_document_number: string
  supplier_company_id: string
  identity_validated_by_salesperson?: boolean
}

export interface SignUpPayloadForMerchant {
  email: string
  password: string
  name: string
  phone: string
  supplier_id: string | null
  natural_person_document_number: string
  company_document_number: string
  identity_validated_by_salesperson?: boolean
}

export interface SignUpPayload {
  email: string
  password: string
  name: string
  phone: string
  supplier_id: string | null
  natural_person_document_number: string
  company_document_number: string
  terms?: Partial<Term>[]
  referral_supplier?: string
}

export enum SignUpFeedbackStatus {
  PENDING_LIMIT = 'pending',
  WAITING_LIMIT = 'waiting',
  POWER_OF_ATTORNEY_ANALYSIS = 'power-of-attorney-analysis',
  REJECTED_LIMIT = 'rejected',
  NOT_OWNER = 'not-owner',
  GENERIC_ERROR = 'generic',
  EMAIL_EXISTS = 'email-exists',
  PHONE_EXISTS = 'phone-exists',
  DOCUMENTS_ANALYSIS = 'documents-analysis',
  NEWLY_FOUNDED = 'newly-founded',
  WAITING_OWNER_BIOMETRICS = 'waiting-owner-biometrics',
  SIGN_UP_ALMOST_THERE = 'almost-there',
}

export type SignUpFeedback = {
  status: SignUpFeedbackStatus
  context?: {
    email?: string
    phone?: string
  }
}

export interface PreSignUpResponse {
  id: string
  name: string
  natural_person_document_type: string
  natural_person_document_number: string
  email: string
  mobile_phone: string
  company_document_type: string
  company_document_number: string
  origin: string
  company_id: string
  newly_founded: boolean
}
